import React from 'react';
import '../css/buttons.css';

const SubmitButton = ({text, onClickButton}) => {
    return (
        <button className='submit-button' onClick={onClickButton}>
            {text}
        </button>
    );
}

export {SubmitButton};
